module.exports = __webpack_public_path__ + "static/img/pic_aed_kcpx@2x.fbadc29f.png";